import backofficeService from "@/api/backoffice";

export default {
  record(data) {
    return backofficeService.Api().post("clientDiagnostic", data);
  },
  getAll(params = {}) {
    return backofficeService.Api().get("clientDiagnostic", { params });
  },
};
